// Used to trigger a TypeScript error if the type of the value is not 'never'
export const assertNever = (value: never, description: string, valueForMessage?: string) =>
    new Error('Unexpected ' + description + ': ' + (valueForMessage || value))
